export default {
  'Sample photo': '샘플 사진',
  Removing: '제거하는 중입니다.',
  Edit: '편집',
  'Adjust Picture': '그림 조정',
  Restore: '복원',
  Eraser: '지우개',
  Size: '크기',
  Background: '배경화면',
  Custom: '사용자 정의',
  Presets: '사전 설정',
  'Add Image': '이미지 추가',
  'Scale to Fit': '적합한 축척',
  'Full Width': '전폭',
  'Full Height': '전체 높이',
  Move: '이동',
  Undo: '실행 취소',
  Redo: '다시 실행',
  Enlarge: '확대',
  Reduce: '줄이다',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw 온라인 배경 제거제',
    desc: '사진 배경을 100% 자동으로 쉽게 무료로 삭제할 수 있습니다.',
    imgAlt: 'photo background remover',
    submitBtn: '배경 제거하기',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
      "Upload failed, click to try again": "Upload failed, click to try again",
};
